/*
 * UtilisationManagement.tsx
 * Author: fwunderlich
 * Date: 11.01.2024
 *
 * Copyright: DMT GmbH & Co. KG
 */
import '../style/Stammdaten.scss';

import React, {useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';
import {checkPermission} from '../functions/functionLibrary';
import {permissions} from '../config/permissions';
import ViewButtons from '../components/global/ViewButtons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faBuildingCircleExclamation,
    faExclamationTriangle, faFileArrowUp,
    faHandshake,
    faCropSimple
} from '@fortawesome/free-solid-svg-icons';
import LayoutMainContentTabMenu from '../components/global/LayoutMainContentTabMenu';
import {
    useCheckImportPersonsQuery,
    useDeletePersonMutation,
    useTransferImportDataQuery
} from '../redux/rtk/injectedPersonApi';
import {Nullable, onClickShowMap} from '../components/functions/Global';
import {UtilisationOverview} from '../components/projectMasterData/utilisation/UtilisationOverview';
import UnderConstruction from './pages/UnderConstruction';
import {
    buttonCSVImport,
    buttonCSVImportData,
    buttonShowMap,
    makeButtonItem
} from '../components/global/viewButtonSelection';
import {Splitter, SplitterPanel} from 'primereact/splitter';
import {classNames} from 'primereact/utils';
import GeoData from './GeoData';
import {MeasureOverview} from '../components/projectMasterData/measure/MeasureOverview';
import ImportOverview from '../components/projectMasterData/imports/ImportOverview';
import {PersonOverview} from '../components/globalData/person/PersonOverview';
import {UtilisationParcelOverview} from '../components/projectMasterData/utilisation/UtilisationParcelOverview';
import {Utilisation} from '../components/functions/ProjectMasterData';

type Props = {
    project: any
}

const ProjectMasterData = (props: Props): JSX.Element => {
    const showMapTempLS: Nullable<string> = localStorage.getItem('showMap');
    const showMapTemp = showMapTempLS === 'true';
    const [showMap, setShowMap] = useState<boolean>(showMapTemp);
    const [showImportPreview, setShowImportPreview] = useState<boolean>(false);
    const [activeIndex, setActiveIndex] = useState(props.project ? 0 : 3);
    const [realIndexValue, setRealIndexValue] = useState(null);
    const {t} = useTranslation(['common']);

    const projectId = props.project ? props.project.id : '';

    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [menuItems, setMenuItems] = useState<any[]>([]);
    const [selectedUtilisationed, setSelectedUtilisationes] = useState<Utilisation[]>([]);
    const [viewButtonsRerender, setViewButtonsRerender] = useState<boolean>(true);

    const userString = localStorage.getItem('user');
    let user: any = {};

    if (userString) {
        user = JSON.parse(userString)[0];
    }

    const person = useCheckImportPersonsQuery({projectId: projectId});

    useEffect(() => {
        if (checkPermission(permissions.isAdmin)) {
            setIsAdmin(true);
        }
        console.log(user);
    }, []);

    useEffect(() => {
        setShowMap(showMapTemp);
    }, [showMapTemp]);

    useEffect(() => {

        const items: any [] = [];

        // if (Array.isArray(person.data)) {
        //     items.push(makeButtonItem(buttonCSVImport, t, () => {
        //
        //     }, true, false));
        // } else {
        //     items.push(makeButtonItem(buttonCSVImportData, t, () => {
        //
        //     }, true, false));
        // }

        // items.push(makeButtonItem(buttonShowMap, t, () => {
        //     onClickShowMap(setShowMap);
        // }, true, false));

        const itemsMeasure: any[] = [...items];

        const itemsUtil: any[] = [...items];

        const itemsAppointment: any[] = [...items];

        const itemsFrameworkValues: any[] = [...items];

        setMenuItems([
            {
                id: 'Measure',
                label: t('projectMasterData:measures.plural'),
                icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faBuildingCircleExclamation}/>,
                component: <MeasureOverview
                    projectId={props.project ? props.project.id : ''}
                    editable={true}
                    expandable={true}
                    hideGlobalFilter={false}
                    showColumnFilters={true}
                    selectable={true}
                    multiSelection={true}
                />,
                buttons: <ViewButtons title={t('')} items={itemsMeasure} rerender={viewButtonsRerender}/>,
                visible: checkPermission(permissions.isAdmin) || checkPermission(permissions.seeMeasures) || checkPermission(permissions.editMeasures)
            },
            {
                id: 'Utilisation',
                label: t('projectMasterData:utilisation.plural'),
                icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faExclamationTriangle}/>,
                component: <UtilisationParcelOverview
                    projectId={props.project ? props.project.id : ''}
                    editable={false} // TODO: check permission
                    expandable={true}
                    hideGlobalFilter={false}
                    showColumnFilters={true}
                    selectable={false}
                    multiSelection={true}
                    onSelection={onSelectionPerson}
                    hideButtons={true}
                />,
                buttons: <ViewButtons title={t('')} items={itemsUtil} rerender={viewButtonsRerender}/>,
                visible: checkPermission(permissions.isAdmin) || checkPermission(permissions.seeUtilisation) || checkPermission(permissions.editUtilisation)
            },
            {
                id: 'Appointment',
                label: t('appointment:plural'),
                icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faHandshake}/>,
                component: <UnderConstruction/>,
                buttons: <ViewButtons title={t('')} items={itemsAppointment} rerender={viewButtonsRerender}/>,
                disabled: true
            },
            {
                id: 'FrameworkValues',
                label: t('management:frameworkValues'),
                icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faCropSimple}/>,
                component: <UnderConstruction/>,
                buttons: <ViewButtons title={t('')} items={itemsFrameworkValues} rerender={viewButtonsRerender}/>,
                disabled: true
            },
            {
                id: 'Import',
                label: t('globalData:global:csvimport'),
                icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faFileArrowUp}/>,
                component: <ImportOverview project={props.project}/>,
                disabled: true
            },
        ]);
    }, [person.data, selectedUtilisationed]);


    const onSelectionPerson = (e: any) => {
        setSelectedUtilisationes(e);
    };

    const handleIndexCallback = (value: any) => {
        console.log(value);
        setRealIndexValue(value);
    };

    const hideDialog = () => {
    };

    useEffect(() => {
        if (realIndexValue === 4) {
            setShowMap(false);
            setShowImportPreview(true);
        } else {
            setShowImportPreview(false);
        }
    }, [realIndexValue]);


    return (
        <LayoutMainContentTabMenu project={props.project} items={menuItems} activeIndex={activeIndex}
                                  parentCallback={handleIndexCallback} showMap={false}
                                  onTabChange={(e: any) => {
                                      setViewButtonsRerender(!viewButtonsRerender);
                                      setActiveIndex(e.index);
                                  }}/>
    );
};

export default ProjectMasterData;
